import styled from 'styled-components';

export const YearPanelSC = styled.div`
  --day-height: 32px;
  --selected-range: ${({ theme }) => theme.color.state.hover};
  --day-color: ${({ theme }) => theme.color.tint.action};
  --border-radius: 16px;
  --selected-day: ${({ theme }) => theme.color.solid.selection};
  --today-color: ${({ theme }) => theme.color.solid.accent};

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 8px;
  align-items: center;
  margin: 8px 0;

  .year {
    padding: 0 16px;
    background-color: transparent;
    border: 0;
    height: var(--day-height);
    color: var(--day-color);

    border-radius: var(--border-radius);
    cursor: pointer;
    transition: all 0.2s;
    ${({ theme }) => theme.mappedTypography.buttonText.default};
  }

  .year:hover {
    background-color: var(--selected-range);
  }

  .year.now {
    color: var(--today-color);
  }

  .year.active {
    color: var(--day-color);
    background-color: var(--selected-range);
  }

  .year.selected {
    background-color: var(--selected-day);
    color: ${({ theme }) => theme.color.tint.action};
  }

  button.year:disabled,
  .calendar-header__button:disabled {
    opacity: 0.45;
  }
`;
